import { render, staticRenderFns } from "./CommodityAllocationListDetail.vue?vue&type=template&id=285a3536&scoped=true"
import script from "./CommodityAllocationListDetail.vue?vue&type=script&lang=js"
export * from "./CommodityAllocationListDetail.vue?vue&type=script&lang=js"
import style0 from "./CommodityAllocationListDetail.vue?vue&type=style&index=0&id=285a3536&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285a3536",
  null
  
)

export default component.exports